// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileAndTabletStub_container__1XHdC","text":"MobileAndTabletStub_text__2zs5v"};